module.exports = __webpack_public_path__ + "img/login_pic.c28be.png";